import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getCreditNoteNumber(cookies, plantId, cnDate) {
    const url = `${apiBaseUrl}/credit_notes/credit_note_number/?plant_id=${plantId}&cn_date=${cnDate}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getCreditNotes(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = `${apiBaseUrl}/credit_notes/${query ? `?${query}` : ''}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getCreditNoteDetails(cookies, creditNoteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/credit_notes/${creditNoteId}/`)
        .then((response) => response.data);
}

export async function printCreditNote(cookies, creditNoteId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/credit_notes/${creditNoteId}/print_credit_note/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export async function getInvoicesForCreditNote(cookies, plantId, customerId) {
    const url = `${apiBaseUrl}/credit_notes/invoices_for_customer/?plant_id=${plantId}&customer_id=${customerId}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getCreditNoteInvoiceContext(cookies, invoiceId, excludeCnId = '') {
    let url = `${apiBaseUrl}/credit_notes/invoice_context/?invoice_id=${invoiceId}`;
    if (excludeCnId) {
        url += `&exclude_cn_id=${excludeCnId}`;
    }
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export function createCreditNote(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/credit_notes/`, payload)
        .then((response) => response.data);
}

export async function getCreditNoteEinvoiceConfig(cookies, plantId, cnDate, creditAmt = 0, invoiceId = '', buyerGstNo = '') {
    const gstParam = buyerGstNo ? `&buyer_gst_no=${encodeURIComponent(buyerGstNo)}` : '';
    const invoiceParam = invoiceId ? `&invoice_id=${invoiceId}` : '';
    const url = `${apiBaseUrl}/credit_notes/einvoice_config/?plant_id=${plantId}&cn_date=${cnDate}&credit_amt=${creditAmt || 0}${invoiceParam}${gstParam}`;
    return getApiClient(cookies).get(url).then((response) => response.data);
}

export function generateEcreditNote(cookies, creditNoteId) {
    return getApiClient(cookies)
        .post(`${apiBaseUrl}/credit_notes/${creditNoteId}/generate_ecredit_note/`)
        .then((response) => response.data);
}

export function updateCreditNote(cookies, payload, creditNoteId) {
    return getApiClient(cookies).put(`${apiBaseUrl}/credit_notes/${creditNoteId}/`, payload)
        .then((response) => response.data);
}

export function cancelCreditNote(cookies, creditNoteId, payload = {}) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/credit_notes/${creditNoteId}/`, payload)
        .then((response) => response.data);
}

export function deleteCreditNote(cookies, creditNoteId) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/credit_notes/${creditNoteId}/`)
        .then((response) => response.data);
}
